import * as React from 'react';
import styled from 'styled-components';
import { LG } from '@origin-digital/helper';
import { Text } from '@origin-digital/style-guide';

interface InfoTextProps {
  text: string;
}

const InfoText: React.FC<InfoTextProps> = ({ text }) => (
  <InfoTextContainer data-id="info-container">
    <Text size="sm" data-id="info-text" markdown={true} overflow="normal">
      {text}
    </Text>
  </InfoTextContainer>
);

export { InfoText };

const InfoTextContainer = styled.div`
  margin-bottom: 24px;
  ${LG`
    margin-bottom: 32px;
  `}
`;
